import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useEffect } from "react";
import { GridColDef } from "@mui/x-data-grid";
import ErrorIcon from "@mui/icons-material/Error";
import { useTranslation } from "react-i18next";
import { AppDataGrid } from "../../components/datagrid/AppDataGrid";
import { common, input } from "../../i18n";
import { DataError, RowErrorDetail } from "./ImportFilePopup.type";
import {
  WHOLE_FILE_REFUSAL_COLUMN,
  importRefusalMessageKey,
} from "../../service/import-file.service";
import { tableStyle } from "../emission/_components/data-table/EmissionDataTableStyle";

interface Props {
  rows: DataError[];
}

// a refusal's type is a server error code; a header error's type is a phrase like "Missing Column"
const ERROR_CODE = /^[A-Z0-9_]+$/;

const isWholeFileRefusal = (row: RowErrorDetail) =>
  row.row === 0 &&
  row.errorDetails.every(
    (e) => e.column === WHOLE_FILE_REFUSAL_COLUMN && ERROR_CODE.test(e.type)
  );

export const ImportFileErrorTable = (props: Props) => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const columns: GridColDef<RowErrorDetail>[] = [
    {
      field: "row",
      headerName: t("Row"),
      disableColumnMenu: true,
      type: "string",
      headerAlign: "left",
      align: "left",
      flex: 2,
      renderCell: (params) =>
        isWholeFileRefusal(params.row) ? "" : params.row.row,
    },
    {
      field: "errorDetails",
      headerName: t("Detail"),
      disableColumnMenu: true,
      type: "string",
      headerAlign: "left",
      align: "left",
      flex: 10,
      renderCell: (params) => {
        return (
          <List>
            {params.row.errorDetails.map((e) => (
              <ListItem key={`${t(e.type)}-${e.column}`}>
                <ListItemIcon>
                  <ErrorIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    isWholeFileRefusal(params.row)
                      ? t(importRefusalMessageKey(e.type))
                      : `${t(e.type)} : ${e.column}`
                  }
                />
              </ListItem>
            ))}
          </List>
        );
      },
    },
  ];

  useEffect(() => {}, [props.rows]);

  return props.rows.length > 0 ? (
    <Box width={"100%"} marginTop={"20px"}>
      <AppDataGrid
        rows={props.rows}
        columns={columns}
        autoHeight
        getRowHeight={() => "auto"}
        localeText={{
          toolbarQuickFilterPlaceholder: `${t("search")}...`,
        }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: {
              variant: "outlined",
            },
          },
        }}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10, 20]}
        sx={tableStyle("light")}
        sortingOrder={["asc", "desc"]}
        getRowId={(row) => row.row}
      />
    </Box>
  ) : null;
};
